module.exports = __webpack_public_path__ + "media/images/certification-e141a2e21d4e191a7ee94532dc8ab676.svg";